export default __webpack_public_path__ + "static/media/1444.24fbe4c8.png";